import AppFormInput from '../../../../components/ui/AppFormInput';
import React, {useState} from 'react';
import {Button} from 'primereact/button';
import {useMountEffect} from 'primereact/hooks';
import {Divider} from 'primereact/divider';
import PaymentTypeSelector from "./PaymentTypeSelector";
import AppFormSelect from "../../../../components/ui/AppFormSelect";

function PaymentForm({
                         paymentMethods,
                         paymentMethod,
                         phoneNumber,
                         amount,
                         initialAmount,
                         policyNumber,
                         paymentNotes,
                         cardNumber,
                         expiryMonth,
                         expiryYear,
                         cvv,
                         cardHolderName,
                         handlePaymentMethodChange,
                         handlePhoneNumberChange,
                         handleAmountChange,
                         handlePolicyNumberChange,
                         handlePaymentNotesChange,
                         handleCardNumberChange,
                         handleExpiryMonthChange,
                         handleExpiryYearChange,
                         handleCvvChange,
                         handleCardHolderNameChange,
                         setRecurring,
                         handleSetRecurringChange,
                         submitPaymentRequest,
                         balanceFormatted
                     }) {

    const oneMonth = Number(initialAmount);
    const twoMonths = Number(initialAmount) * 2;
    const threeMonths = Number(initialAmount) * 3;

    const paymentOptions = [
        {label: '1 Month $' + oneMonth, amount: oneMonth},
        {label: '2 Months $' + twoMonths, amount: twoMonths},
        {label: '3 Months $' + threeMonths, amount: threeMonths}
    ];

    const [defaultAmount, setAmount] = useState({label: '1 Month', amount: Number(initialAmount)});
    const [defaultMethod, setMethod] = useState(paymentMethod);

    useMountEffect(() => {
        paymentOptions.forEach((element) => {
            if (element.amount === initialAmount) {
                setAmount(element)
            }
        })
    })

    return (
        <form name="principalMemberForm">
            <div className="row g-4">
                <AppFormSelect
                    containerClassName="col-xxl-6 col-xl-6 col-lg-6 mb-3 space-y-1"
                    label="Select payment method"
                    id="paymentMethod"
                    name="paymentMethod"
                    value={defaultMethod}
                    onChange={(e) => {
                        handlePaymentMethodChange(e.target.value)
                        setMethod(e.target.value)
                    }}
                    options={paymentMethods}
                    placeholder="Payment method"
                />
                {defaultMethod && defaultMethod === "Ecocash" && <AppFormInput
                    containerClassName="col-xxl-6 col-xl-6 col-lg-6 mb-3 space-y-1"
                    label="Phone number"
                    type="text"
                    id="phoneNumber"
                    placeholder="Enter phone number"
                    name="phoneNumber"
                    required
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                />}

                {defaultMethod && (defaultMethod === "Ecocash") &&
                    <AppFormSelect
                        containerClassName="col-xxl-6 col-xl-6 col-lg-6 mb-3 space-y-1"
                        label="Balance Due"
                        value={defaultAmount ? JSON.stringify(defaultAmount) : ""}
                        onChange={(e) => {
                            try {
                                const val = JSON.parse(e.target.value);
                                handleAmountChange(val.amount);
                                setAmount(val);
                            } catch (err) {
                            }
                        }}
                        options={paymentOptions}
                        optionLabel="label"
                        placeholder="Choose period"
                    />}
                {defaultMethod && (defaultMethod === "Ecocash" || defaultMethod === "Pay with Visa Card") &&
                    <AppFormInput
                        containerClassName="col-xxl-6 col-xl-6 col-lg-6 mb-3 space-y-1"
                        label="Policy Number"
                        type="text"
                        id="policyNumber"
                        placeholder="Enter policy number"
                        name="policyNumber"
                        required
                        readOnly
                        disabled
                        inputClassName="bg-base-200 text-base-content/70 cursor-not-allowed border-base-300 focus:ring-0"
                        value={policyNumber}
                        onChange={handlePolicyNumberChange}
                    />}

                    {defaultMethod && defaultMethod === "Pay with Visa Card" && (
                        <div className="col-xxl-12 col-xl-12 col-lg-12 mt-3">
                            <PaymentTypeSelector
                                isRecurring={setRecurring}
                                onChange={handleSetRecurringChange}
                            />
                        </div>
                    )}

                {defaultMethod && (defaultMethod === "Ecocash" || defaultMethod === "Pay with Visa Card") &&
                    <div className="text-center mt-5">
                        <Button
                            onClick={submitPaymentRequest}
                            className="justify-content-center text-center mt-4"
                            size="large"
                            outlined
                            label="Continue"
                            icon="pi pi-arrow-right"
                            severity="info"
                            rounded
                            raised
                        />
                    </div>}
                {
                    defaultMethod && defaultMethod === "Pay using Paynow" && <>
                        <Divider type='dashed'/>
                        <iframe src="https://www.topup.co.zw/billpay/widget/doves-funeral-services?iframe=true"
                                title='Doves Visa Payment'
                                style={{
                                    width: "100%", height: '80vw'
                                }}
                        ></iframe>

                    </>
                }
            </div>
        </form>
    );
}

export default PaymentForm;
